/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SearchTermInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SearchTermInput({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/Search/Content/SearchTermInput",
  onChange
  
}) {
let searchTermValueData = fromData.useDataValue({ viewPath,
context: 'search',
path: 'term',
})
let searchTermChangeData = fromData.useDataChange({ viewPath,
context: 'search',
path: 'term',
})
  return (<React.Fragment
>
<div
  data-testid="SearchTermInput.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 className="mousetrap"
 data="search.term"
 onChange={searchTermChangeData}
 value={searchTermValueData}
 placeholder="Search for professionals"
 autoSelect={true}
 className="mousetrap"
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 autoFocus={true}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
</div>
{children}
</React.Fragment>)
}